import { useEffect, useState } from 'react'
import { Client, Activity } from '../../../pure-js/types/GrooverTypes'
import { getClient } from '../libs/DBApiHandler'

export const useClient = (activity: Activity | undefined) => {
  const [client, setClient] = useState<Client | undefined>()

  useEffect(() => {
    let isMounted = true

    const fetchClient = async () => {
      if (activity?.clientId) {
        const clientData = await getClient(activity.clientId)
        if (isMounted && clientData) {
          setClient(clientData)
        }
      }
    }
    fetchClient()

    return () => {
      isMounted = false
    }
  }, [activity])

  return client
}

export const useClientByClientId = (clientId: string | undefined) => {
  const [client, setClient] = useState<Client | undefined>()

  useEffect(() => {
    let isMounted = true

    const fetchClient = async () => {
      if (clientId) {
        const clientData = await getClient(clientId)
        if (isMounted && clientData) {
          setClient(clientData)
        }
      }
    }
    fetchClient()

    return () => {
      isMounted = false
    }
  }, [clientId])

  return client
}
